<template>
    <div class="banner-write-wrapper">
        <div class="banner-table">
            <div class="table-row">
                <div class="table-col square">이미지</div>
                <div class="table-col square">이동</div>
                <div class="table-col small">노출유무</div>
                <div class="table-col small">노출순서</div>
            </div>
            <div class="table-row">
                <div class="table-col square">
                    <div class="popup">
                    <el-upload
                        class="avatar-uploader"
                        :auto-upload="false"
                        action=""
                        :file-list="files"
                        :show-file-list="false"
                        list-type="picture"
                        :on-change="onlyOnePhotoChange"
                    >
                        <img v-if="hasFile()" :src="files[0].url"  class="avatar banner_img">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                        <div class="input_error" v-if="validation.hasError('files')">{{ validation.firstError('files') }}</div>
                    </div>
                </div>
                <div class="table-col square">
                    <el-radio-group  class="link-radio"
                        v-model="linkType" @change="parentChange('linkType', linkType)">
                        <el-radio :label="0">미선택</el-radio>
                        <el-radio :label="1">외부링크</el-radio>
                        <el-radio :label="2">공지사항</el-radio>
                        <el-radio :label="3">이벤트</el-radio>
                    </el-radio-group>
                    <!-- 외부링크 -->
                    <div v-if="linkType ===1" class="link_box">
                        <el-input v-model="linkUrl"
                                  placeholder="http://, https://로 입력"
                                  @input="parentChange('linkUrl', linkUrl)"></el-input>
                        <div class="input_error pt5" v-if="validation.hasError('linkUrl')">{{ validation.firstError('linkUrl') }}</div>
                    </div>
                    <!-- 공지사항 -->
                    <div v-if="linkType ===2" class="pt10">
                        <el-button @click="$modal.show('banner-notice-list-modal')">선택</el-button>
                        <span class="pl10">{{ noticeTitle }}</span>
                        <div class="input_error pt5" v-if="validation.hasError('linkBoardKey')">{{ validation.firstError('linkBoardKey') }}</div>
                    </div>
                    <!-- 이벤트 -->
                    <div v-if="linkType ===3" class="pt10">
                        <el-button @click="$modal.show('banner-event-list-modal')">선택</el-button>
                        <span class="pl10">{{ eventTitle }}</span>
                        <div class="input_error pt5" v-if="validation.hasError('linkBoardKey')">{{ validation.firstError('linkBoardKey') }}</div>
                    </div>
                </div>
                <div class="table-col small">
                    <el-radio-group v-model="display" @change="parentChange('display', display)">
                  <el-radio :label="0">미노출</el-radio>
                  <el-radio :label="1">노출</el-radio>
                </el-radio-group>
                    <div class="input_error pt5" v-if="validation.hasError('display')">{{ validation.firstError('display') }}</div>
                </div>
                <div class="table-col small">
                    <div class="seq_box">
                     <el-input v-model="seq" @input="parentChange('seq', seq)"></el-input>
                        <div class="input_error pt5" v-if="validation.hasError('seq')">{{ validation.firstError('seq') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <banner-notice-list-modal></banner-notice-list-modal>
        <banner-event-list-modal></banner-event-list-modal>
    </div>
</template>

<script>
import util from "@/mixins/util";
import elFileMixins from "@/mixins/elFileMixins";
import bannerValidator from "@/mixins/validators/bannerValidator";
import BannerNoticeListModal from "@/components/modal/BannerNoticeListModal";
import BannerEventListModal from "@/components/modal/BannerEventListModal";
import EventBus from "@/utils/event-bus";

export default {
    name: "BannerWritePopupLayout",
    mixins: [elFileMixins,bannerValidator],
    inject: ['bannerWriteSetData'],
    components: {
        BannerNoticeListModal,
        BannerEventListModal
    },
    provide() {
        return {}
    },
    props: {
        bannerData: {
            default: () => {
                return []
            }
        },
    },
    data() {
        return {
            noticeTitle:'',
            eventTitle:'',
        }
    },
    created() {
    },
    mounted() {
        if (this.hasData()) {
            this.initSetData();
        }
        EventBus.$on('boardListSelectAfter', this.userContentSelect)
        EventBus.$on('BannerWritePopupLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('boardListSelectAfter')
        EventBus.$off('BannerWritePopupLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        hasData() {
            return !util.isEmpty(this.bannerData);
        },
        initSetData() {
              this.linkType = this.bannerData.pu_linked_type
              this.parentChange('linkType',this.linkType)

                this.seq = this.bannerData.pu_seq
            this.parentChange('seq',this.seq)

            this.display = this.bannerData.pu_is_display
            this.parentChange('display',this.display)

            if(this.linkType === 1){
                this.linkUrl = this.bannerData.pu_linked_url
                this.parentChange('linkUrl',this.linkUrl)
            }

            if(this.linkType === 2 || this.linkType === 3){
                this.linkBoardKey = this.bannerData.pu_linked_idx
                this.parentChange('linkBoardKey',this.linkBoardKey)

            }

            if(this.linkType ===2){
                this.noticeTitle = this.bannerData.board_title
            }

            if(this.linkType ===3){
                this.eventTitle = this.bannerData.board_title
            }

            if(!util.isEmpty(this.bannerData.File) && !util.isEmpty(this.bannerData.File[0].a_idx)){
                this.files = this.bannerData.File;
                this.files[0].url = this.bannerData.File[0].org_url
                this.parentChange('files',this.files)
            }
        },
        parentChange(key, value) {
            if(key === 'linkType'){
                // 전부 초기화
                this.linkBoardKey = ''
                this.noticeTitle = ''
                this.eventTitle = ''
                this.linkUrl =''

                this.bannerWriteSetData('linkBoardKey',this.linkBoardKey)
                this.bannerWriteSetData('linkUrl',this.linkUrl)
            }

            this.bannerWriteSetData(key, value);
        },
        hasFile() {
            return !util.isEmpty(this.files);
        },
        userContentSelect(type,data){ //
            if(type === 'notice'){
                this.noticeTitle = data.wr_subject
            }
            if(type === 'event'){
                this.eventTitle = data.wr_subject
            }
            this.linkBoardKey = data.wr_id
            this.parentChange('linkBoardKey',this.linkBoardKey)
            this.parentChange('noticeTitle',this.noticeTitle)
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
